/**
 * accountId を URL クエリ `?account` に紐付けるフック
 *
 * リロード・ブラウザ戻る・ブックマークで選択が復元されるよう、
 * state ではなく URL を唯一の真実にする（PredictionErrorEvaluationPage と同じ手法）。
 */

import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

const ACCOUNT_PARAM = 'account';

export interface AccountIdParamState {
  accountId: string;
  setAccountId: (accountId: string) => void;
}

export function useAccountIdParam(): AccountIdParamState {
  const [searchParams, setSearchParams] = useSearchParams();
  const accountId = searchParams.get(ACCOUNT_PARAM) ?? '';

  const setAccountId = useCallback(
    (nextAccountId: string) => {
      const next = new URLSearchParams(searchParams);
      next.set(ACCOUNT_PARAM, nextAccountId);
      setSearchParams(next, { replace: true });
    },
    [searchParams, setSearchParams],
  );

  return { accountId, setAccountId };
}
